import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import * as moment from 'moment';
import { CommonService } from 'src/app/services/common/common.service';
import { StorageService } from 'src/app/services/storage/storage.service';

@Component({
	selector: 'app-beneficiary-operations',
	templateUrl: './beneficiary-operations.component.html',
	styleUrls: ['./beneficiary-operations.component.scss']
})
export class BeneficiaryOperationsComponent implements OnInit {
	@Input() beneficiary_data: any;
	@Input() beneficiaries_list: any;
	@Input() client_data: any;
	@Input() operation_type: any;

	@Output() beneficiaryOperationsClosed = new EventEmitter<any>();
	@Output() beneficiaryOperationsUpdated = new EventEmitter<any>();

	user_details: any;

	constructor(
		public commonService: CommonService,
		private storageService: StorageService,
		private dialog: MatDialog,
		private datePipe: DatePipe,
	) { }

	ngOnInit(): void {
		this.user_details = this.storageService.get("user_details");

		this.getGenders();
		this.getRelationships();

		if (this.operation_type == "Add") {
			this.beneficiary_data = this.ideal_beneficiary_data;
		}

		if (this.operation_type == "Add" || this.operation_type == "Edit") {
			setTimeout(() => {
				this.openBeneficiaryOperationModal();
			}, 200);
		} else if (this.operation_type == "Delete") {
			setTimeout(() => {
				this.openDeleteBeneficiary();
			}, 200);
		}


	}

	genders_list: any = [];
	getGenders() {
		this.commonService.getData('/gender?no_page=true/').subscribe(
			(res: any) => {
				this.genders_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}


	relationships_list: any = [];
	getRelationships() {
		this.commonService.getData('/relationship?no_page=true/').subscribe(
			(res: any) => {
				this.relationships_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}


	ideal_beneficiary_data: any = {
		first_name: "",
		last_name: "",
		email: "",
		birth_date: "",
		gender: "",
		gender_name: "",
		relationship_type: "",
		relationship_type_name: "",
		percentage_allocation: "",
	};
	beneficiary_data_errors: any = {
		first_name: false,
		last_name: false,
		email: false,
		birth_date: false,
		gender: false,
		gender_name: false,
		relationship_type: false,
		relationship_type_name: false,
		percentage_allocation: false,
	};

	resetTrustedContactData() {
		this.ideal_beneficiary_data = {
			first_name: "",
			last_name: "",
			email: "",
			birth_date: "",
			gender: "",
			gender_name: "",
			relationship_type: "",
			relationship_type_name: "",
			percentage_allocation: "",
		};
		this.beneficiary_data_errors = {
			first_name: false,
			last_name: false,
			email: false,
			birth_date: false,
			gender: false,
			gender_name: false,
			relationship_type: false,
			relationship_type_name: false,
			percentage_allocation: false,
		};
	}

	validEmail(email) {
		if (
			email != '' &&
			/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)
		) {
			return true;
		} else {
			return false;
		}
	}

	validatePhoneNumber(number) {
		const regex = /^[\+][(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/gm;
		if (number == null || number == '') {
			return false;
		}

		if (regex.test(number) == true) {
			return true;
		} else {
			return false;
		}
	}

	@ViewChild('beneficiaryOperationModal') beneficiaryOperationModal: TemplateRef<any>;
	private beneficiaryOperationModalRef: MatDialogRef<TemplateRef<any>>;
	openBeneficiaryOperationModal() {
		if (this.operation_type == "Edit") {
			this.beneficiary_data.birth_date = this.datePipe.transform(this.beneficiary_data.birth_date, 'MM-dd-yyyy');
		}

		this.beneficiaryOperationModalRef = this.dialog.open(this.beneficiaryOperationModal, { disableClose: true });
		this.beneficiaryOperationModalRef.afterClosed().subscribe((result) => {
			this.closeBeneficiaryOperationModal();
		});
	}

	closeBeneficiaryOperationModal() {
		this.resetBeneficiaryData();
		this.beneficiaryOperationModalRef.close();
		this.beneficiaryOperationsClosed.emit("Closed");
	}

	checkPercentageAllocation() {
		if (this.beneficiaries_list.length == 0) {
			this.beneficiary_data.percentage_allocation = parseInt(this.beneficiary_data.percentage_allocation);
		  if (parseInt(this.beneficiary_data.percentage_allocation) > 100) {
			return false;
		  } else {
			return true;
		  }
		} else {
		  let beneficiary_index = null;
		  if (this.operation_type == "Add") {
			beneficiary_index = null;
		  } else {
			beneficiary_index = this.beneficiaries_list.findIndex((x) => x.id == this.beneficiary_data.id);
		  }
		  let allocation_value: any = 0;
		  for (let index = 0; index < this.beneficiaries_list.length; index++) {
			allocation_value = allocation_value + parseInt(this.beneficiaries_list[index].percentage_allocation);
		  }
		  if (this.operation_type == "Add") {
			allocation_value = allocation_value;
		  } else {
			allocation_value = allocation_value - parseInt(this.beneficiaries_list[beneficiary_index].percentage_allocation);
		  }
		  if ((allocation_value + parseInt(this.beneficiary_data.percentage_allocation)) > 100) {
			return false;
		  } else {
			return true;
		  }
		}
	  }

	saveBeneficiaryData() {

		if (
			this.beneficiary_data.first_name != "" &&
			this.beneficiary_data.first_name != null
		) {
			this.beneficiary_data_errors.first_name = false;
		} else {
			this.beneficiary_data_errors.first_name = true;
		}

		if (
			this.beneficiary_data.last_name != "" &&
			this.beneficiary_data.last_name != null
		) {
			this.beneficiary_data_errors.last_name = false;
		} else {
			this.beneficiary_data_errors.last_name = true;
		}

		// if (
		// 	this.beneficiary_data.email != "" &&
		// 	this.beneficiary_data.email != null &&
		// 	this.validEmail(this.beneficiary_data.email)
		// ) {
		// 	this.beneficiary_data_errors.email = false;
		// } else {
		// 	this.beneficiary_data_errors.email = true;
		// }

		// if (
		// 	this.beneficiary_data.is_primary != "" &&
		// 	this.beneficiary_data.is_primary != null
		// ) {
		// 	this.beneficiary_data_errors.is_primary = false;
		// } else {
		// 	this.beneficiary_data_errors.is_primary = true;
		// }

		// if (
		// 	this.beneficiary_data.birth_date != "" &&
		// 	this.beneficiary_data.birth_date != null
		// ) {
		// 	this.beneficiary_data_errors.birth_date = false;
		// } else {
		// 	this.beneficiary_data_errors.birth_date = true;
		// }

		// if (
		// 	this.beneficiary_data.gender != "" &&
		// 	this.beneficiary_data.gender != null
		// ) {
		// 	this.beneficiary_data_errors.gender = false;
		// } else {
		// 	this.beneficiary_data_errors.gender = true;
		// }

		// if (
		// 	this.beneficiary_data.relationship_type != "" &&
		// 	this.beneficiary_data.relationship_type != null
		// ) {
		// 	this.beneficiary_data_errors.relationship_type = false;
		// } else {
		// 	this.beneficiary_data_errors.relationship_type = true;
		// }

		if (
			this.beneficiary_data.percentage_allocation != ""  &&
			this.checkPercentageAllocation()
		) {
			this.beneficiary_data_errors.percentage_allocation = false;
		} else {
			this.beneficiary_data_errors.percentage_allocation = true;
		}

		// this.beneficiary_data_errors.percentage_allocation = false;

		if (
			this.beneficiary_data_errors.first_name == false &&
			this.beneficiary_data_errors.last_name == false &&
			// this.beneficiary_data_errors.is_primary == false &&
			// this.beneficiary_data_errors.email == false &&
			// this.beneficiary_data_errors.birth_date == false &&
			// this.beneficiary_data_errors.gender == false &&
			// this.beneficiary_data_errors.relationship_type == false &&
			this.beneficiary_data_errors.percentage_allocation == false
		) {
			let payload: any = this.beneficiary_data;

			payload.business_area = this.user_details.role.business_area[0];

			if(this.beneficiary_data.birth_date != "" && this.beneficiary_data.birth_date != null) {
                payload.birth_date = moment(payload.birth_date).format();
            } else {
				delete payload['birth_date'];
			}

			if(this.beneficiary_data_errors.birth_date == true) {
				delete payload['birth_date'];
			}
			if(this.beneficiary_data_errors.percentage_allocation == true){
				payload.percentage_allocation = 0
			}


			payload.client = this.client_data.id;
			if (this.operation_type == 'Add') {
				this.commonService
				.postData('/beneficiary', payload)
				.subscribe(
					(res: any) => {
						// this.table_data[this.show_beneficiaries].beneficiaries.push(res);
						// this.getClientsData();
						this.commonService.showToast(
							'success',
							'Beneficiary Added Successfully.',
						);
						this.beneficiaryOperationsUpdated.emit("Added");
						// this.closeBeneficiaryOperationModal();
						this.resetBeneficiaryData();
						this.beneficiaryOperationModalRef.close();
					},
					(err) => {
						this.commonService.showToast('error', err.error);
					},
				);
			} else if (this.operation_type == 'Edit') {
				this.commonService
				.patch(
					'/beneficiary/' + payload.id,
					payload,
				)
				.subscribe(
					(res: any) => {
						// const index = this.table_data[this.show_beneficiaries].beneficiaries.findIndex(
						//   (x) => x.id == this.beneficiary_data.id,
						// );
						// this.table_data[this.show_beneficiaries].beneficiaries.splice(index, 1, res);
						// this.getClientsData();
						this.commonService.showToast(
							'success',
							'Beneficiary Updated Successfully.',
						);
						this.beneficiaryOperationsUpdated.emit("Updated");
						// this.closeBeneficiaryOperationModal();
						this.resetBeneficiaryData();
						this.beneficiaryOperationModalRef.close();
					},
					(err) => {
						this.commonService.showToast('error', err.error);
					},
				);
			}
		}
	}

	resetBeneficiaryData() {
		this.beneficiary_data = {
			first_name: "",
			last_name: "",
			email: "",
			birth_date: "",
			gender: "",
			gender_name: "",
			relationship_type: "",
			relationship_type_name: "",
			percentage_allocation: "",
		};
		this.beneficiary_data_errors = {
			first_name: false,
			last_name: false,
			email: false,
			birth_date: false,
			gender: false,
			gender_name: false,
			relationship_type: false,
			relationship_type_name: false,
			percentage_allocation: false,
		};
	}

	@ViewChild('beneficiaryDeleteModal') beneficiaryDeleteModal: TemplateRef<any>;
	private beneficiaryDeleteModalRef: MatDialogRef<TemplateRef<any>>;

	openDeleteBeneficiary() {
		this.beneficiaryDeleteModalRef = this.dialog.open(this.beneficiaryDeleteModal, { disableClose: true });
		this.beneficiaryDeleteModalRef.afterClosed().subscribe((result) => {
			this.closeBeneficiaryDeleteModal();
		});
	}

	closeBeneficiaryDeleteModal() {
		this.resetBeneficiaryData();
		this.beneficiaryDeleteModalRef.close();
	}

	deleteBeneficiaryData() {
		const payload = [this.beneficiary_data.id];
		this.commonService.delete('/beneficiary/destroy?ids=' + payload).subscribe(
			(res: any) => {
				this.commonService.showToast(
					'success',
					'Beneficiary Deleted Successfully.',
				);

				this.beneficiaryOperationsUpdated.emit("Deleted");

				// const index = this.table_data[this.show_beneficiaries].beneficiaries.findIndex(
				// 	(x) => x.id == this.beneficiary_data.id,
				// );
				// this.table_data[this.show_beneficiaries].beneficiaries.splice(index, 1);

				this.resetBeneficiaryData();
				this.beneficiaryOperationModalRef.close();
				// this.closeBeneficiaryDeleteModal();
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	numberOnly(event): boolean {
		const charCode = event.which ? event.which : event.keyCode;
		if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
			return false;
		}
	}

}
